import QuestionsModal from './QuestionsModal';

export default QuestionsModal;
